import { combineReducers } from 'redux';
import clientDetails from './clientDetails';
import clientsList from './clientsList';
import clientsRecentList from './clientsRecentList';
import cart from './cart';
import checkout from './checkout';
import orderHistory from './orderHistory';
import orderDetails from './orderDetails';
import resendReceipt from './resendReceipt';
import addressValidation from './addressValidation';
import groups from './groups';
import loyalty from './loyalty';
import reasonToContact from './reasonToContact';
import reminders from './reminders';

const appReducer = combineReducers({
  clientsList,
  clientsRecentList,
  clientDetails,
  cart,
  checkout,
  orderHistory,
  orderDetails,
  resendReceipt,
  addressValidation,
  groups,
  loyalty,
  reasonToContact,
  reminders,
});

export default (state, action) => appReducer(state, action);
